import PhotoBox from './PhotoBox';

export default PhotoBox;
